export const telegramConfig = {
  bot_id: 'kyzwnbot',
  token: '5236535548:AAGGP0hILb9Iu2NhGtFEXJW4oR4Z2Y1A7Hw',
  chatID: '-1001632098466'
};

